// extracted by css-extract-rspack-plugin
export default {"presetActionList":"PresetsMenu-module__presetActionList__rRDei8Y"};